module.exports = __webpack_public_path__ + "static/img/icon77.afd4731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon77.png
// module id = xj7r
// module chunks = 0